import * as client from './baseClient';

export const getHazardsByBranch = (branchId) =>
  client.get(`/api/hazards/branch/${branchId}`);

export const getHazardsByCompany = (companyId) =>
  client.get(`/api/hazards/company/${companyId}`);

export const createHazard = (hazard, loggedInUserId) =>
  client.post('/api/hazards', hazard, undefined, loggedInUserId);

export const editHazard = (hazard, loggedInUserId) =>
  client.put(`/api/hazards/${hazard.id}`, hazard, undefined, loggedInUserId);

export const deleteHazard = (hazardId, loggedInUserId) =>
  client._delete(
    `/api/hazards/${hazardId}`,
    undefined,
    undefined,
    loggedInUserId
  );

export const getControlsForHazard = (hazardId) =>
  client.get(`/api/hazards/${hazardId}/controls`);

export const deleteHazardControl = (payload, loggedInUserId) =>
  client._delete(
    `/api/hazards/${payload.hazardId}/controls/${payload.id}`,
    undefined,
    undefined,
    loggedInUserId
  );

export const createControl = (payload, loggedInUserId) =>
  client.post(
    `/api/hazards/${payload.hazardId}/controls`,
    payload,
    undefined,
    loggedInUserId
  );

export const updateControl = (payload, loggedInUserId) =>
  client.put(
    `/api/hazards/${payload.hazardId}/controls/${payload.id}`,
    payload,
    undefined,
    loggedInUserId
  );

//Reviews
export const getReviewsForHazard = (hazardId) =>
  client.get(`/api/hazards/${hazardId}/reviews`);

export const deleteHazardReview = (payload, loggedInUserId) =>
  client._delete(
    `/api/hazards/${payload.hazardId}/reviews/${payload.reviewId}`,
    undefined,
    undefined,
    loggedInUserId
  );

export const createReview = (payload, loggedInUserId) =>
  client.post(
    `/api/hazards/${payload.hazardId}/reviews`,
    payload,
    undefined,
    loggedInUserId
  );

export const updateReview = (payload, loggedInUserId) =>
  client.put(
    `/api/hazards/${payload.hazardId}/reviews/${payload.id}`,
    payload,
    undefined,
    loggedInUserId
  );

//management logs
export const getManagementLogsForHazard = (hazardId) =>
  client.get(`/api/hazards/${hazardId}/logs`);

export const deleteHazardManagementLog = (payload, loggedInUserId) =>
  client._delete(
    `/api/hazards/${payload.hazardId}/logs/${payload.reviewId}`,
    undefined,
    undefined,
    loggedInUserId
  );

export const createManagementLog = (payload, loggedInUserId) =>
  client.post(
    `/api/hazards/${payload.hazardId}/logs`,
    payload,
    undefined,
    loggedInUserId
  );

export const updateManagementLog = (payload, loggedInUserId) =>
  client.put(
    `/api/hazards/${payload.hazardId}/logs/${payload.id}`,
    payload,
    undefined,
    loggedInUserId
  );
